import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Provider } from '@angular/core';

import { MSAL_INSTANCE, MsalBroadcastService, MsalGuard, MsalService } from '@azure/msal-angular';
import { BrowserCacheLocation, IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { CAM_AUTH_TOKEN, CamUserService } from '@camelot/user';

import { environment } from 'src/environments/environment';

import { AzureAuthService } from './azure-auth.service';
import { AzureInterceptor } from './azure.interceptor';

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.AADB2C.msalConfig.auth.clientId,
      authority: environment.AADB2C.b2cPolicies.authorities.signUpSignIn.authority,
      redirectUri: environment.AADB2C.redirectUri,
      postLogoutRedirectUri: environment.AADB2C.postLogoutRedirectUri,
      knownAuthorities: [environment.AADB2C.b2cPolicies.authorityDomain],
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false,
      },
      windowHashTimeout: 1000,
      iframeHashTimeout: 1000,
      redirectNavigationTimeout: 1000,
    },
  });
}
export function loggerCallback(logLevel: LogLevel, message: string) {}

export const provideAzure = (): Provider => [
  {
    provide: MSAL_INSTANCE,
    useFactory: MSALInstanceFactory,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: AzureInterceptor,
    multi: true,
  },
  CamUserService,
  MsalBroadcastService,
  MsalGuard,
  MsalService,
  { provide: CAM_AUTH_TOKEN, useExisting: AzureAuthService },
];
